import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NoRouteComponent } from '../../components/no-route/no-route.component';
import { TranslateModule } from '@ngx-translate/core';
import { CrowdinOtaService } from '../../../../services/crowdin-ota/crowdin-ota.service';
import { LanguageService } from '../../../../services/language.service';
import { TranslationService } from '../../../../services/translation.service';

@Component({
    selector: 'app-privacy-page',
    templateUrl: './privacy-page.component.html',
    styleUrls: ['./privacy-page.component.scss'],
    imports: [TranslateModule, NoRouteComponent],
    standalone: true
})
export class PrivacyPageComponent implements OnInit {
  isNotFound: boolean = false;
  globalLang: string = 'en-GB';
  translationsArray: any;
  content: string = 'CP_PRIVACY_TEMPLATE';
  isTranslationDone: boolean = false;

  constructor(private readonly _translationService: TranslationService,
    private readonly _actRoute: ActivatedRoute,
    private readonly _crowdinService: CrowdinOtaService,
    private readonly languageService: LanguageService) {
    const langId = this.languageService.getLanguage();
    const userLang = navigator.language;
    if (!langId || !this.languageService.checkIsValideLanguage(langId)) {
      this.isNotFound = true;
    } else {
      this.isNotFound = false;
      this.globalLang = langId && this.languageService.checkIsValideLanguage(langId) ? langId :
      (userLang && this.languageService.checkIsValideLanguage(userLang) ? userLang : 'en-GB');
    }
  }

  ngOnInit(): void {
    this.content = 'CP_PRIVACY_TEMPLATE';
    const languageCode = this.globalLang.split('-')[0];
    this._crowdinService.useLanguage(languageCode);
  }

}
